// Trợ lý AI: nút nổi góc phải dưới màn hình + khung chat
import React, { useEffect, useState } from "react";

/** Biểu tượng trợ lý AI: bong bóng chat + tia sáng */
export function AiIcon({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <path d="M4 11.5C4 7.36 7.58 4 12 4s8 3.36 8 7.5S16.42 19 12 19c-1.1 0-2.15-.2-3.1-.58L4.6 20l1.15-3.55A7.1 7.1 0 0 1 4 11.5Z"
        stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M12 7.6l1.05 2.55 2.55 1.05-2.55 1.05L12 14.8l-1.05-2.55L8.4 11.2l2.55-1.05L12 7.6Z" fill="currentColor" />
      <path d="M19 1.8l.45 1.15 1.15.45-1.15.45L19 5l-.45-1.15-1.15-.45 1.15-.45L19 1.8Z" fill="currentColor" />
    </svg>
  );
}

export function ChatBot() {
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    if (!chatOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setChatOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [chatOpen]);

  return (
    <>
      {/* Khung chat — mở lên từ nút ở góc phải */}
      <div
        style={{ height: "min(28rem, calc(100vh - 140px))" }}
        className={`
              chat-window fixed z-50
              bottom-[88px] lg:bottom-[96px]
              right-3 sm:right-4 lg:right-6
              left-3 sm:left-auto
              w-auto sm:w-[360px]
              bg-gray-900/95 backdrop-blur-xl rounded-2xl
              border border-gray-700 shadow-2xl
              flex flex-col transform origin-bottom-right
              transition-all duration-300
              ${chatOpen ? 'scale-100 opacity-100 pointer-events-auto' : 'scale-75 opacity-0 pointer-events-none'}
            `}
      >
          {/* Header */}
          <div className="bg-gradient-to-r from-teal-500 via-cyan-600 to-indigo-600 p-3 sm:p-4 rounded-t-2xl flex items-center justify-between shadow-md relative overflow-hidden flex-shrink-0">
            <div className="absolute inset-0 bg-white/10" />
            <div className="flex items-center space-x-3 relative z-10 min-w-0">
              <div className="w-7 sm:w-8 h-7 sm:h-8 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-sm shadow-inner flex-shrink-0">
                <AiIcon className="h-4 w-4 text-white" />
              </div>
              <div className="min-w-0">
                <h3 className="text-white font-medium text-xs sm:text-sm drop-shadow-sm truncate">Khothi AI Assistant</h3>
                <p className="text-blue-100 text-[9px] sm:text-[10px] flex items-center">
                  <span className="w-1 sm:w-1.5 h-1 sm:h-1.5 rounded-full bg-green-400 mr-1 shadow-[0_0_5px_#4ade80] flex-shrink-0" />
                  <span className="truncate">Đang trực tuyến</span>
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setChatOpen(false)}
              aria-label="Close chat"
              className="text-white/70 hover:text-white transition-colors relative z-10 p-1 w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/20 flex-shrink-0"
            >
              <i className="fa-solid fa-xmark text-sm" />
            </button>
          </div>
  
          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-3 sm:p-4 flex flex-col space-y-3 sm:space-y-4 custom-scrollbar">
            <div className="flex justify-center">
              <span className="text-[9px] sm:text-[10px] text-gray-500 bg-gray-800/50 px-2 py-0.5 rounded-full">Hôm nay</span>
            </div>
  
            <div className="flex items-start space-x-2">
              <div className="w-6 sm:w-7 h-6 sm:h-7 rounded-full bg-cyan-500/15 flex-shrink-0 flex items-center justify-center mt-1 border border-cyan-400/30">
                <AiIcon className="h-3.5 w-3.5 text-cyan-300" />
              </div>
              <div className="bg-gray-800 rounded-2xl rounded-tl-sm px-3 sm:px-4 py-2 max-w-[85%] border border-gray-700/50 shadow-sm">
                <p className="text-xs sm:text-sm text-gray-200">
                  Xin chào Ngọc! 👋 Tôi là trợ lý ảo của Khơ Thị. Tôi có thể giúp gì cho bạn hôm nay?
                </p>
                <span className="text-[8px] sm:text-[9px] text-gray-500 mt-1 block text-right">11:58</span>
              </div>
            </div>
  
            <div className="flex flex-wrap gap-1 sm:gap-2 ml-8">
              <button
                type="button"
                className="text-[9px] sm:text-xs bg-gray-800/50 hover:bg-blue-600 hover:border-blue-500 border border-gray-700 text-gray-300 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full transition-all duration-200 shadow-sm whitespace-nowrap"
              >
                📅 Lịch họp
              </button>
              <button
                type="button"
                className="text-[9px] sm:text-xs bg-gray-800/50 hover:bg-blue-600 hover:border-blue-500 border border-gray-700 text-gray-300 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full transition-all duration-200 shadow-sm whitespace-nowrap"
              >
                📝 Đề xuất mới
              </button>
              <button
                type="button"
                className="text-[9px] sm:text-xs bg-gray-800/50 hover:bg-blue-600 hover:border-blue-500 border border-gray-700 text-gray-300 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full transition-all duration-200 shadow-sm whitespace-nowrap"
              >
                🔍 Tài liệu
              </button>
            </div>
          </div>
  
          {/* Input */}
          <div className="p-2 sm:p-3 border-t border-gray-800 bg-gray-900/80 rounded-b-2xl flex-shrink-0">
            <div className="relative flex items-center bg-gray-800/80 rounded-full border border-gray-700 focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 transition-all duration-200 px-2 py-1">
              <button type="button" aria-label="Attach file" className="text-gray-400 hover:text-blue-400 p-1 sm:p-2 transition-colors rounded-full hover:bg-gray-700/50 flex items-center justify-center w-6 sm:w-8 h-6 sm:h-8 flex-shrink-0">
                <i className="fa-solid fa-paperclip text-xs sm:text-sm" />
              </button>
              <input
                type="text"
                placeholder="Nhập..."
                className="flex-1 bg-transparent border-none outline-none text-xs sm:text-sm text-gray-200 px-2 placeholder-gray-500 min-w-0"
              />
              <button type="button" aria-label="Send message" className="text-white bg-blue-600 hover:bg-blue-500 p-1 sm:p-2 transition-colors rounded-full w-6 sm:w-8 h-6 sm:h-8 flex items-center justify-center shadow-md flex-shrink-0">
                <i className="fa-solid fa-paper-plane text-xs" />
              </button>
            </div>
          </div>
        </div>

      {/* Nút trợ lý AI */}
      <div className="group fixed bottom-5 right-4 z-50 flex items-center gap-3 lg:bottom-6 lg:right-6">
        {!chatOpen && (
          <span className="pointer-events-none hidden translate-x-2 rounded-full border border-white/10 bg-gray-900/90 px-3 py-1.5 text-xs font-medium text-white opacity-0 shadow-lg backdrop-blur transition group-hover:translate-x-0 group-hover:opacity-100 sm:block">
            Trợ lý AI Khơ Thị
          </span>
        )}
        <button
          type="button"
          onClick={() => setChatOpen((v) => !v)}
          aria-label={chatOpen ? "Đóng trợ lý AI" : "Mở trợ lý AI"}
          aria-expanded={chatOpen}
          className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-teal-400 via-cyan-500 to-indigo-500 text-white shadow-lg shadow-cyan-500/30 ring-4 ring-white/10 transition hover:scale-105 hover:shadow-cyan-400/50 active:scale-95"
        >
          {!chatOpen && <span className="absolute inset-0 animate-ping rounded-full bg-cyan-400/30 [animation-duration:2.5s]" />}
          <span className={`relative transition duration-300 ${chatOpen ? "rotate-90 scale-0 opacity-0" : "rotate-0 scale-100 opacity-100"}`}>
            <AiIcon className="h-7 w-7" />
          </span>
          <i className={`fa-solid fa-xmark absolute text-xl transition duration-300 ${chatOpen ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0"}`} />
          <span className="absolute right-0.5 top-0.5 h-3 w-3 rounded-full border-2 border-slate-900 bg-emerald-400" title="Đang trực tuyến" />
        </button>
      </div>
    </>
  );
}
